<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" 
            v-loading="loading"
            element-loading-background = "rgba(255, 255,255,0.7)"
            element-loading-text = "保存中..."
            :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item  prop="name" label="分组方案名称">
                    <el-input v-model="form.name" maxlength="15" style="width:200px;"></el-input>
                </el-form-item>
                <el-form-item   prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" max="999" type="number" style="width:200px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                form:{
                    id:"",
                    userId:"",
                    name:"",
                    orderNum:"",
                },  
                rules: {
                    name: [
                        { required: true, message: '请输入分组方案名称', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
        },
        created:function () {
        },
        methods:{
            init(data, userId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }

                this.form.userId = userId;

                // 初始
                this.form.id = data.id;
                this.form.name = data.name;
                this.form.orderNum = data.orderNum;
                

            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.groupSchemeUpdateUrl;
                        let data = {
                            id:this.form.id,
                            userId:this.form.userId,
                            name:this.form.name,
                            orderNum:this.form.orderNum,
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.loading=true;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/set/classroomtime/group/update.vue